import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize, first, take } from 'rxjs/operators';

import { DarkThemeService } from '@core/theme/dark-theme.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AvailabilityService } from '@services/availability.service';
import { AlertService } from '@shared/alert/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from 'src/app/auth/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
    templateUrl: 'login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
    loginForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    isCheckAvailable: boolean = true;
    show_password = false;

    err_msg = '';

    isdev = !environment.production;

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthService,
        private alertService: AlertService,
        public availService: AvailabilityService,
        public darkThemeService: DarkThemeService,
        private spinner: NgxSpinnerService,
        private modalService: NgbModal
    ) {
        // redirect to home if already logged in
        if (this.authenticationService.current_user) {
            this.router.navigate(['/colaborador']);
        }
    }

    ngOnInit() {
        this.createLoginForm();
        this.checkAvailable();

        // get return url from route parameters or default to '/'
        this.returnUrl =
            this.route.snapshot.queryParams['returnUrl'] || '/colaborador';
    }

    createLoginForm() {
        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required],
        });
    }

    checkAvailable() {
        this.availService
            .check()
            .pipe(
                take(1),
                finalize(() => {
                    this.isCheckAvailable =
                        this.availService.api_available.value;

                    if (!this.isCheckAvailable) {
                        this.loginForm.disable();
                    }
                })
            )
            .subscribe();
    }

    reload() {
        window.location.reload();
    }
    // convenience getter for easy access to form fields
    get f() {
        return this.loginForm.controls;
    }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        this.alertService.clear();

        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }

        this.spinner.show();
        this.authenticationService
            .login({
                username: this.f.username.value,
                password: this.f.password.value,
            })
            .pipe(first())
            .subscribe(
                data => {
                    this.spinner.hide();
                    this.router.navigate([this.returnUrl]);
                },
                error => {
                    this.alertService.error('Erro na autenticação');
                    this.spinner.hide();
                    if (error['error'].non_field_errors) {
                        this.err_msg = error['error'].non_field_errors[0];
                    } else {
                        this.err_msg =
                            error['name'] + '\n' + error['statusText'];
                        switch (error.status) {
                            case 0:
                                this.err_msg =
                                    'Servidor de autenticação indisponível';
                        }
                    }
                }
            );
    }

    //exibe mensagem ao enviar a request para redefinir senha pegando no parametro o cpf digitado
    redefinirSenha() {
        const cpf = this.loginForm.get('username').value;
        this.spinner.show();

        this.authenticationService.alterarSenha(cpf).subscribe(
            res => {
                // Sucesso
                this.alertService.success(res['message']);
                this.spinner.hide();
            },
            err => {
                // Erro
                this.alertService.error(err.error.message);
                this.spinner.hide();
            }
        );
    }

    open(content) {
        this.modalService.open(content, {
            ariaLabelledBy: 'modal-basic-title',
            size: 'x',
        });
    }
}
